import React from "react";
import ScannableCodeDisplay from "./scannable_code_display/ScannableCodeDisplay";

import "./ScannableCodeFullscreen.scss";

export default function ScannableCodeFullscreen({ url, value, width, onClose }) {

	const innerClose = () => {
		onClose?.();
	}

	const code_click = () => {
		if (url) {
			window.open(url, "_blank");
		}
	}

	return (
		<div data-component="ScannableCodeDisplay" onClick={innerClose}>
			<ScannableCodeDisplay
				value={url ?? value}
				width={width ?? 250}
				onCodeClick={code_click}
			/>
		</div>
	);
}